import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import '@/styles/index.scss' // global css

// 置灰
// import './assets/css/grayscale.css'

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

// 全局组件
import navbar from '@/components/navbar'
Vue.component('navbar', navbar)

import myLoading from '@/components/loading'
Vue.component('my-loading', myLoading)
import loadingtwo from '@/components/loadingtwo'
Vue.component('loading-btn', loadingtwo)

import toastRegistry from '@/components/toast/index'
Vue.use(toastRegistry)

import md5 from 'js-md5'
Vue.prototype.$md5 = md5

import jsCookie from 'js-cookie'
Vue.prototype.$cookie = jsCookie

import axios from 'axios'
Vue.prototype.$http = axios
import { ws } from '@/utils/websocket.js'
Vue.prototype.$globalSocket = ws

// 时间戳转换过滤器
Vue.filter('dateFormat', (dataStr) => {
  let len = dataStr.toString().length
  let time
  if (len == 10) {
    time = new Date(parseInt(dataStr) * 1000)
  } else if (len == 13) {
    time = new Date(parseInt(dataStr))
  }
  function timeAdd0(str) {
    if (str < 10) {
      str = '0' + str
    }
    return str
  }
  if (time == undefined) {
    return
  }
  let y = time.getFullYear()
  let m = time.getMonth() + 1
  let d = time.getDate()
  let h = time.getHours()
  let mm = time.getMinutes()
  let s = time.getSeconds()
  let dateTime =
    y +
    '-' +
    timeAdd0(m) +
    '-' +
    timeAdd0(d) +
    ' ' +
    timeAdd0(h) +
    ':' +
    timeAdd0(mm) +
    ':' +
    timeAdd0(s)
  return dateTime
})

// 头部携带token
axios.interceptors.request.use(
  (config) => {
    // 判断是否存在token，如果存在的话，则每个http header都加上token
    // let token = sessionStorage.getItem('Authorization')
    let token = jsCookie.get('Authorization')
    if (!config.headers.hasOwnProperty('Authorization') && token) {
      config.headers.Authorization = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

Vue.config.productionTip = false
//Vue.prototype.$websocketurl = 'ws://192.168.0.57:81/'//本地测试websocket连接
if (window.location.protocol === 'https:') {
  // 网址以https开头
  Vue.prototype.$websocketurl = 'wss://www.zyecp.com/' //正式websocket连接
} else {
  // 网址以http开头
  Vue.prototype.$websocketurl = 'ws://www.zyecp.com/' //正式websocket连接
}
//Vue.prototype.$imgpath = 'http://192.168.0.57:81/'//本地测试上传图片的时候的图片地址
Vue.prototype.$imgpath = 'http://www.zyecp.com/'
Vue.prototype.$fileupload = 'http://192.168.0.102:7081/'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js